import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const WarningSolidIcon = createIcon(
  'WarningSolid',
  // @todo fix offset
  <path d="M2.0013712,17.0075 L17.0613712,17.0075 C18.6013712,17.0075 19.5613712,15.3375 18.7913712,14.0075 L11.2613712,0.9975 C10.4913712,-0.3325 8.5713712,-0.3325 7.8013712,0.9975 L0.271371202,14.0075 C-0.498628798,15.3375 0.461371202,17.0075 2.0013712,17.0075 Z M9.5313712,10.0075 C8.9813712,10.0075 8.5313712,9.5575 8.5313712,9.0075 L8.5313712,7.0075 C8.5313712,6.4575 8.9813712,6.0075 9.5313712,6.0075 C10.0813712,6.0075 10.5313712,6.4575 10.5313712,7.0075 L10.5313712,9.0075 C10.5313712,9.5575 10.0813712,10.0075 9.5313712,10.0075 Z M10.5313712,14.0075 L8.5313712,14.0075 L8.5313712,12.0075 L10.5313712,12.0075 L10.5313712,14.0075 Z" />
);

WarningSolidIcon.error = true;

export default WarningSolidIcon;
